<!-- src/components/layout/DefaultFooter.vue -->

<script setup lang="ts">
  import SecretFooterControls from '@/components/layout/SecretFooterControls.vue';
  import SecretFooterAttribution from '@/components/layout/SecretFooterAttribution.vue';
  import { WindowService } from '@/services/window.service';
  import type { LayoutProps } from '@/types/ui/layouts';

  withDefaults(defineProps<LayoutProps>(), {
    displayPoweredBy: true,
  });

  const windowProps = WindowService.getMultiple(['site_host', 'ot_version']);
</script>

<template>
  <footer
    class="w-full min-w-[320px]"
    :aria-label="$t('site-footer')">
    <div class="flex flex-col items-center space-y-8 py-8">
      <SecretFooterControls :show-language="true" />
      <SecretFooterAttribution
        :site-host="windowProps.site_host ?? ''"
        :show-nav="displayPoweredBy"
        :show-terms="displayPoweredBy"
        :version="windowProps.ot_version" />
    </div>
  </footer>
</template>
